import React from "react";

import { Eyebrow, Title, ShieldIcon } from "../components/CommonComponents";
import MetaInfo from "../components/MetaInfo";
import Header from "../components/Header";
import Footer from "../components/Footer";


const studentSections = [
    {
        number: "01",
        id: "general-conduct",
        shortTitle: "General Conduct",
        label: "Conduct & Attendance",
        title: "General Conduct and Attendance",
        description: "Standards governing attendance, classroom behaviour, leave, campus movement and participation in academic activities.",
        points: [
            "Students planning to participate in a tour or picnic may request for relaxation of the dress code by submitting a letter of intention certified by their parent or guardian. Upon approval, the student will be issued a permission, which must be kept along with the ID card and presented to the authorities on demand during the period of tour for dress code relaxation.",
            "A six-day working schedule from Monday to Saturday is followed. Classes are scheduled from 9.15 a.m. to 3.00 p.m.",
            "Students shall rise from their seats when the teacher enters the classroom and remain standing till the teacher takes her/his seat or they are allowed by the teacher to sit. Silence shall be observed during class hours.",
            "Teachers shall be greeted appropriately with \"Good Morning Sir/Madam\" or \"Good Afternoon Sir/Madam\" and a \"Thank you Sir/Madam\" when the teacher leaves the classroom.",
            "No student shall enter or leave the classroom when the session is on without the permission of the teacher concerned.",
            "Students having lab sessions in the AN, have to report to the lab directly in time and they are not expected to go to the classroom.",
            "In events of Student seminars/project presentations, etc., it is compulsory that all the students of the concerned class be present for the entire session.",
            "Students can leave the campus during class hours only after getting a gate pass from the Principal, HoD, or the tutor and after making an entry in the Gate Register maintained by the gatekeeper.",
            "All students shall leave the classes immediately after 4.15 p.m. No students shall wander or gather in the verandah, corridor, and staircase, etc. Do not spend much time in canteen, coffee shops, etc.",
            "All leave applications (Regular) shall be submitted in time, for sanction by the HoD and concerned teachers. The application for medical leave shall be accompanied by valid medical certificates.",
        ],
    },
    {
        number: "02",
        id: "dress-code",
        shortTitle: "Dress Code",
        label: "Identity & Appearance",
        title: "Dress Code and Appearance",
        description: "Standards relating to University uniform, identity cards, appropriate appearance and dress-code compliance.",
        points: [
            "Students shall come to the college in approved uniforms with formal shirts tucked into trousers with a black belt and black shoes or semi-covered shoes. Hawaii-type rubber or plastic chappals are not permitted. In addition, lady students will have a blazer over their shirts. Besides, those who are in laboratories shall wear their respective lab-coat.",
            "Students shall not make any alterations to the Uniform issued from the college without the permission of the concerned HoD, and any violation of this will attract a fine of Rs 300, and repetition of this could result in suspension from the university.",
            "All the students are expected to attend all college functions in college uniform unless otherwise specified.",
            "All the students shall wear their identity cards, well displayed. The identity badge is a public document and any teaching staff and non-teaching staff shall have the right to peruse it. Denial of it will attract disciplinary action.",
            "Students planning to make a tour, picnic can avail relaxation in the dress code by producing a letter of intention certified by their parent/guardian. The student will be issued a permission token to be kept along with the ID card to be shown to the authorities on demand during the period of the dress code relaxation.",
            "All kinds of tattooing, body piercing, hairstyling, etc. that go against the existing social norms and which could go against the spirit of the academic values will be referred to the discipline committee.",
            "Any dress code violation noticed within the campus will attract a fine of Rs.300 coupled with disciplinary actions.",
        ],
    },
    {
        number: "03",
        id: "campus-facilities",
        shortTitle: "Campus & Property",
        label: "Campus Responsibility",
        title: "Campus Facilities and Property",
        description: "Guidelines for responsible use of University spaces, academic facilities, equipment and common infrastructure.",
        points: [
            "As per the Govt. order, students shall not bring powered vehicles inside the campus.",
            "Students are expected to maintain silence in the academic buildings as the decorum, and any deviant behaviour such as hooting, whistling, loitering, etc. will be treated as an instance of indiscipline.",
            "For independent study, students are expected to use the reading rooms, library, or the demarcated areas of the academic building and shall not resort to sitting in staircases or circulation areas where they could interrupt the free movement of the academic community.",
            "Students are encouraged to make use of the library, common computing facilities and to involve in professional body activities or any programme authorized by the college beyond class hours. However, under normal circumstances, students shall retreat to their hostels or residences by 6.00 PM.",
            "Access to academic buildings beyond the above timing and on holidays without written permission from the concerned HoD will be treated as a case of indiscipline.",
            "Keeping the campus clean is an obligation of the student. Waste in the campus is to be kept in the waste baskets. Any violation of this shall attract a minimum fine of Rs. 100/- per violation with a warning.",
            "It is strongly advised to refrain from activities such as scribbling or noting on walls, doors, or furniture which could deface the college and destroy the academic ambiance.",
            "The students are directed to handle the furniture, equipment, fixtures, and appliances of the college and lab carefully. The students are also required to follow safety precautions near moving machines and electrical installations. In the event of damage to property, the responsible students will have to bear the cost of replacement/repair with a fine.",
        ],
    },
    {
        number: "04",
        id: "prohibited-activities",
        shortTitle: "Prohibited Activities",
        label: "Discipline & Safety",
        title: "Prohibited Activities",
        description: "Activities that compromise discipline, safety, dignity or the academic environment are prohibited across the campus.",
        points: [
            "Consumption of intoxicants / psychotropic substances in any form or smoking or using chewing gum, panmasala, etc. are strictly prohibited in the campus.",
            "Students are not permitted to arrange any unauthorized celebrations and decorations of any in the campus.",
            "Students are not permitted to distribute or display (both physically and electronically) material such as notices, banners, X'mas stars, etc. in the campus without the permission of the competent authority.",
            "Political activity in any form is not permitted in the university campus. Unauthorized meetings, propaganda, processions, or fund collections are forbidden within the Campus, hostels, and outside the campus.",
            "Harassing juniors, ill-treatment to other fellow students, or any form of ragging is objectionable and liable to be treated as a criminal offense by the law enforcing agencies as per the directives of Hon'ble Supreme Court of India.",
            "Misbehaviour female students, threatening or violence against members of the staff or fellow students will be considered as serious cases of misconduct.",
        ],
    },
    {
        number: "05",
        id: "academic-policies",
        shortTitle: "Academic Policies",
        label: "Academic Responsibility",
        title: "Academic Policies",
        description: "Academic participation, examinations, representation and on-duty leave are governed by established University procedures.",
        points: [
            "Students are expected to make use of academic, co-curricular and extracurricular facilities available to an optimum level. This will certainly make them physically fit, academically competent, mentally alert, and socially sensitive.",
            "Students who intend to represent the campus or college in interuniversity events shall take prior permission from the Registrar, and the selection will be based on parameters such as academic performance, attendance, character, existing academic assignment, and competence of the student in the proposed event for participation.",
            "On-duty leave applications will not be entertained beyond 10 working days from the actual date of leave under any circumstance. The maximum number of on-duty leave admissible is restricted to 10 days per semester.",
            "During the period of internal examinations, students are not allowed to leave the hall within one hour from the beginning of the exam, and students have to occupy the seat 5 minutes before the commencement of the examination.",
            "The third series test will be optional, and the students who desire to attend this need to register well in advance with the concerned member of faculty. The syllabus for the third series shall cover 3rd and 4th modules from the university syllabus.",
        ],
    },
    {
        number: "06",
        id: "financial-matters",
        shortTitle: "Financial Matters",
        label: "Financial Responsibility",
        title: "Financial Matters",
        description: "Students are expected to fulfil their financial obligations to the University within the prescribed timelines.",
        points: [
            "The students are required to pay fees, mess bills, etc. in advance or in time, which will avoid fines.",
            "Any violation of the above rules will invite a penalty in the form of warning, fine, calling parents, or any course of corrective measure as found suitable by the discipline committee.",
            "Expulsion from the University is also expulsion from the hostel.",
        ],
    },
    {
        number: "07",
        id: "mobile-policy",
        shortTitle: "Mobile Policy",
        label: "Digital Conduct",
        title: "Mobile Phone Policy",
        description: "Guidelines regulating mobile phone possession and usage within the University campus.",
        intro: "The purpose of this policy is to establish a guideline regarding the usage of mobile phones inside the campus. This policy is applicable to all those who enter the campus.",
        points: [
            "Realizing the importance of communication and the possible impact of mobile phone usage inside the campus, the following guidelines are arrived at.",
            "Students are not permitted to use mobile phones within the campus.",
            "Students who are staying in the university hostels should not bring the mobile phones to the university.",
            "Day scholars carrying mobile phones to the college shall deposit the same in the designated place before 8.55 AM and can collect the same after 4.10 PM.",
            "The mobile phones shall be kept in silent mode while depositing in the designated place.",
            "All the staff members are empowered to confiscate mobile phones found with students violating the above rules.",
            "Students violating the rules will be fined an amount of Rs 1000/- and the confiscated mobile phones will be returned to the parents of the students.",
            "Staff members are allowed to use mobile phones in their respective cabins.",
        ],
    },
];


export default function CodeOfConductStudent() {
    return (
        <>
            <MetaInfo param="" id="about" />
            <Header school="common" />

            <main className="bg-white text-[#132337]">

                {/* HERO */}

                <section className="relative overflow-hidden bg-[#071A2F] pt-[100px] text-white">

                    {/* BACKGROUND */}
                    <div className="pointer-events-none absolute inset-0">

                        <div className="absolute inset-y-0 right-0 w-[41%] bg-[#0C2744]" />

                        <div className="absolute right-0 top-0 h-full w-[41%] opacity-[0.045] [background-image:linear-gradient(rgba(255,255,255,.7)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,.7)_1px,transparent_1px)] [background-size:54px_54px]" />

                        <div className="absolute -bottom-[320px] -left-[230px] h-[620px] w-[620px] rounded-full border border-white/[0.04]" />

                        <div className="absolute -bottom-[230px] -left-[140px] h-[440px] w-[440px] rounded-full border border-[#D5AD57]/10" />

                        <div className="absolute bottom-0 left-0 h-[5px] w-[30%] bg-[#8B1E3F]" />

                        <div className="absolute bottom-0 left-[30%] h-[5px] w-[15%] bg-[#D5AD57]" />

                    </div>


                    <div className="relative mx-auto grid min-h-[590px] w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)] lg:grid-cols-[1.08fr_.92fr]">

                        {/* LEFT */}
                        <div className="flex flex-col justify-center py-16 pr-8 lg:py-20 lg:pr-20">

                            <div className="flex items-center gap-4 text-sm font-bold uppercase tracking-[0.18em] text-[#D5AD57]">

                                <span className="h-px w-12 bg-current" />

                                Student Code of Conduct

                            </div>


                            <h1 className="mt-7 max-w-[830px] font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(52px,6vw,88px)] font-normal leading-[0.96] tracking-[-0.045em]">

                                Learning with purpose.

                                <span className="block text-[#D5AD57]">
                                    Conduct with responsibility.
                                </span>

                            </h1>


                            <p className="mt-8 max-w-[690px] text-[17px] leading-8 text-white/65">

                                The Student Code of Conduct establishes the standards of behaviour, academic discipline and personal responsibility expected from every student as a member of the ISBM University community.

                            </p>


                            <div className="mt-10 flex flex-wrap gap-x-8 gap-y-4 border-t border-white/15 pt-7">

                                {[
                                    "Academic Discipline",
                                    "Respect",
                                    "Responsibility",
                                    "Campus Integrity",
                                ].map((item) => (
                                    <div key={item} className="flex items-center gap-3">

                                        <span className="h-1.5 w-1.5 rotate-45 bg-[#D5AD57]" />

                                        <span className="text-[10px] font-bold uppercase tracking-[0.14em] text-white/65">
                                            {item}
                                        </span>

                                    </div>
                                ))}

                            </div>

                        </div>


                        {/* RIGHT */}
                        <div className="relative hidden border-l border-white/10 lg:flex lg:items-center">

                            <span className="absolute right-[-10px] top-[-40px] font-['Libre_Caslon_Display',Georgia,serif] text-[270px] font-normal leading-none tracking-[-0.08em] text-white/[0.03]">
                                07
                            </span>


                            <div className="relative w-full px-10 xl:px-14">

                                <div className="flex items-center justify-between">

                                    <div className="grid h-16 w-16 place-items-center rounded-full border border-[#D5AD57]/40 text-[#D5AD57]">
                                        <ShieldIcon />
                                    </div>

                                    <div className="text-right">

                                        <strong className="block font-['Libre_Caslon_Display',Georgia,serif] text-[58px] font-normal leading-none text-[#D5AD57]">
                                            07
                                        </strong>

                                        <span className="mt-2 block text-[9px] font-bold uppercase tracking-[0.16em] text-white/40">
                                            Conduct Areas
                                        </span>

                                    </div>

                                </div>


                                <div className="mt-9">

                                    <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#D5AD57]">
                                        Student Responsibility Framework
                                    </span>

                                    <h2 className="mt-4 max-w-[440px] font-['Libre_Caslon_Display',Georgia,serif] text-[35px] font-normal leading-[1.15]">
                                        Standards that shape responsible campus life.
                                    </h2>

                                </div>


                                <div className="mt-9 border-t border-white/10">

                                    {[
                                        ["01", "Conduct & Attendance"],
                                        ["02", "Dress & Appearance"],
                                        ["03", "Campus & Property"],
                                        ["04", "Prohibited Activities"],
                                        ["05", "Academic Policies"],
                                        ["06", "Financial Matters"],
                                        ["07", "Mobile Phone Policy"],
                                    ].map(([number, title]) => (
                                        <div key={number} className="grid grid-cols-[38px_1fr_auto] items-center border-b border-white/10 py-3">

                                            <span className="font-['Libre_Caslon_Display',Georgia,serif] text-[17px] text-[#D5AD57]">
                                                {number}
                                            </span>

                                            <span className="text-[10px] font-bold uppercase tracking-[0.1em] text-white/55">
                                                {title}
                                            </span>

                                            <span className="h-1.5 w-1.5 rotate-45 bg-[#D5AD57]/50" />

                                        </div>
                                    ))}

                                </div>

                            </div>

                        </div>

                    </div>

                </section>


                {/* STUDENT CONDUCT CONTENT */}

                <section className="relative bg-[#F7F2E8] py-20 sm:py-24 lg:py-28">

                    <div className="mx-auto w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)]">

                        {/* HEADER */}
                        <div className="grid gap-10 border-b border-[#071A2F]/15 pb-11 lg:grid-cols-[1fr_430px] lg:items-end">

                            <div>

                                <Eyebrow>
                                    Student Code of Conduct
                                </Eyebrow>

                                <Title
                                    before="Standards for Responsible"
                                    highlight="Student Life"
                                    after=""
                                    position="middle"
                                    theme="burgundy"
                                />

                            </div>


                            <p className="text-[15px] leading-8 text-[#65727E]">

                                These standards provide a clear framework for student behaviour, attendance, appearance, academic participation, use of campus facilities and responsible conduct.

                            </p>

                        </div>


                        {/* ====================================================== */}
                        {/* SIDEBAR + NORMAL PAGE CONTENT */}
                        {/* ====================================================== */}

                        <div className="mt-14 grid gap-12 lg:grid-cols-[300px_minmax(0,1fr)] lg:items-start lg:gap-16">

                            {/* STICKY SIDEBAR */}
                            <aside className="sticky top-[145px] hidden self-start lg:block">

                                <div className="border border-[#071A2F]/10 bg-white">

                                    <div className="border-b border-[#071A2F]/10 p-6">

                                        <div className="flex items-center justify-between">

                                            <span className="text-[10px] font-bold uppercase tracking-[0.17em] text-[#8B1E3F]">
                                                Student Standards
                                            </span>

                                            <span className="font-['Libre_Caslon_Display',Georgia,serif] text-[23px] text-[#D5AD57]">
                                                08
                                            </span>

                                        </div>


                                        <p className="mt-3 font-['Libre_Caslon_Display',Georgia,serif] text-[24px] leading-[1.2] text-[#071A2F]">
                                            Code of Conduct
                                        </p>

                                    </div>


                                    <nav className="px-6">

                                        {studentSections.map((item) => (
                                            <a key={item.id} href={`#${item.id}`} className="group grid grid-cols-[34px_1fr_auto] items-center gap-3 border-b border-[#071A2F]/10 py-3.5 last:border-b-0">

                                                <span className="font-['Libre_Caslon_Display',Georgia,serif] text-[17px] text-[#D5AD57]">
                                                    {item.number}
                                                </span>

                                                <span className="text-[12px] font-semibold leading-5 text-[#071A2F]/60 transition group-hover:text-[#8B1E3F]">
                                                    {item.shortTitle}
                                                </span>

                                                <span className="text-[#8B1E3F]/25 transition group-hover:translate-x-1 group-hover:text-[#8B1E3F]">
                                                    →
                                                </span>

                                            </a>
                                        ))}


                                        <a href="#disciplinary-procedures" className="group grid grid-cols-[34px_1fr_auto] items-center gap-3 border-b border-[#071A2F]/10 py-3.5">

                                            <span className="font-['Libre_Caslon_Display',Georgia,serif] text-[17px] text-[#D5AD57]">
                                                08
                                            </span>

                                            <span className="text-[12px] font-semibold leading-5 text-[#071A2F]/60 transition group-hover:text-[#8B1E3F]">
                                                Discipline & Fine Policy
                                            </span>

                                            <span className="text-[#8B1E3F]/25 transition group-hover:translate-x-1 group-hover:text-[#8B1E3F]">
                                                →
                                            </span>

                                        </a>

                                    </nav>

                                </div>


                                <div className="mt-5 bg-[#071A2F] p-6 text-white">

                                    <span className="text-[9px] font-bold uppercase tracking-[0.16em] text-[#D5AD57]">
                                        Student Principle
                                    </span>

                                    <p className="mt-4 font-['Libre_Caslon_Display',Georgia,serif] text-[24px] leading-[1.3]">
                                        Your conduct shapes the community you learn in.
                                    </p>

                                </div>

                            </aside>


                            {/* MAIN CONTENT */}
                            <div className="min-w-0">

                                {/* CONTENT INTRO */}
                                <div className="mb-3 flex items-end justify-between border-b border-[#071A2F]/15 pb-7">

                                    <div>

                                        <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-[#8B1E3F]">
                                            Student Responsibilities
                                        </span>

                                        <h2 className="mt-3 font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(36px,4vw,52px)] font-normal leading-[1.05] text-[#071A2F]">
                                            Campus Conduct Framework
                                        </h2>

                                    </div>

                                    <span className="hidden font-['Libre_Caslon_Display',Georgia,serif] text-[66px] leading-none text-[#D5AD57]/30 sm:block">
                                        01—07
                                    </span>

                                </div>


                                {/* ====================================================== */}
                                {/* POLICY SECTIONS */}
                                {/* ====================================================== */}

                                <div>

                                    {studentSections.map((section, sectionIndex) => (
                                        <article key={section.id} id={section.id} className="scroll-mt-[160px] border-b border-[#071A2F]/15 py-10 first:pt-8">

                                            {/* SECTION HEADING */}
                                            <div className="grid gap-6 md:grid-cols-[105px_1fr]">

                                                <div>

                                                    <span className={`grid h-[72px] w-[72px] place-items-center font-['Libre_Caslon_Display',Georgia,serif] text-[25px] ${sectionIndex === 3 ? "bg-[#8B1E3F] text-white" : "border border-[#D5AD57] bg-white text-[#A77B2D]"}`}>
                                                        {section.number}
                                                    </span>

                                                </div>


                                                <div>

                                                    <span className="text-[9px] font-bold uppercase tracking-[0.17em] text-[#8B1E3F]">
                                                        {section.label}
                                                    </span>

                                                    <h3 className="mt-3 font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(28px,3vw,38px)] font-normal leading-[1.1] text-[#071A2F]">
                                                        {section.title}
                                                    </h3>

                                                    <p className="mt-4 max-w-[760px] text-[14px] leading-7 text-[#65727E]">
                                                        {section.description}
                                                    </p>

                                                </div>

                                            </div>


                                            {/* MOBILE POLICY INTRO */}
                                            {section.intro && (
                                                <div className="mt-8 border-l-[3px] border-[#D5AD57] bg-white px-6 py-5 md:ml-[105px]">

                                                    <span className="text-[9px] font-bold uppercase tracking-[0.16em] text-[#8B1E3F]">
                                                        Introduction
                                                    </span>

                                                    <p className="mt-3 text-[14px] leading-7 text-[#52606C]">
                                                        {section.intro}
                                                    </p>

                                                </div>
                                            )}


                                            {/* RULES */}
                                            <div className="mt-8 md:ml-[105px]">

                                                {section.id === "mobile-policy" && (
                                                    <div className="mb-5">

                                                        <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-[#8B1E3F]">
                                                            Policy Guidelines
                                                        </span>

                                                    </div>
                                                )}


                                                <ol className="border-t border-[#071A2F]/10">

                                                    {section.points.map((point, index) => (
                                                        <li key={index} className="group grid gap-4 border-b border-[#071A2F]/10 py-5 sm:grid-cols-[42px_1fr]">

                                                            <span className="font-['Libre_Caslon_Display',Georgia,serif] text-[18px] text-[#D5AD57]">
                                                                {String(index + 1).padStart(2, "0")}
                                                            </span>

                                                            <p className="text-[14px] leading-7 text-[#52606C]">
                                                                {point}
                                                            </p>

                                                        </li>
                                                    ))}

                                                </ol>

                                            </div>

                                        </article>
                                    ))}

                                </div>


                                {/* ====================================================== */}
                                {/* FINE POLICY */}
                                {/* ====================================================== */}

                                <article id="fine-policy" className="scroll-mt-[160px] mt-10 overflow-hidden bg-[#8B1E3F] text-white">

                                    <div className="grid lg:grid-cols-[240px_1fr]">

                                        <div className="border-b border-white/10 p-8 lg:border-b-0 lg:border-r lg:p-10">

                                            <span className="text-[9px] font-bold uppercase tracking-[0.17em] text-[#D5AD57]">
                                                Accountability
                                            </span>

                                            <strong className="mt-10 block font-['Libre_Caslon_Display',Georgia,serif] text-[66px] font-normal leading-none text-[#D5AD57]">
                                                08
                                            </strong>

                                            <h3 className="mt-6 font-['Libre_Caslon_Display',Georgia,serif] text-[30px] font-normal leading-[1.1]">
                                                Fine Policy
                                            </h3>

                                        </div>


                                        <div className="p-8 lg:p-10">

                                            <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-[#D5AD57]">
                                                Fine Policy of ISBM University
                                            </span>

                                            <p className="mt-5 text-[15px] leading-8 text-white/70">

                                                The money collected from the students as a fine on instances of non-compliance with the rules and norms will be kept in a separate account and will be utilized for purposes such as charity, scholarship, student co-curricular activities, and renovation/maintenance in case of damage to the property.

                                            </p>

                                        </div>

                                    </div>

                                </article>


                                {/* ====================================================== */}
                                {/* DISCIPLINARY PROCEDURES */}
                                {/* ====================================================== */}

                                <article id="disciplinary-procedures" className="scroll-mt-[160px] border border-[#071A2F]/10 bg-white">

                                    <div className="grid lg:grid-cols-[240px_1fr]">

                                        <div className="bg-[#071A2F] p-8 text-white lg:p-10">

                                            <div className="grid h-14 w-14 place-items-center rounded-full border border-[#D5AD57]/40 text-[#D5AD57]">
                                                <ShieldIcon />
                                            </div>

                                            <span className="mt-8 block text-[9px] font-bold uppercase tracking-[0.17em] text-[#D5AD57]">
                                                Student Accountability
                                            </span>

                                            <h3 className="mt-4 font-['Libre_Caslon_Display',Georgia,serif] text-[30px] font-normal leading-[1.15]">
                                                Disciplinary Procedures
                                            </h3>

                                        </div>


                                        <div className="p-8 lg:p-10">

                                            <div className="grid grid-cols-[30px_1fr] gap-5">

                                                <span className="mt-2 h-2 w-2 rotate-45 bg-[#D5AD57]" />

                                                <p className="text-[15px] leading-8 text-[#52606C]">

                                                    In case of any instance of non-compliance of existing rules or any observed matter/behaviour that deviates from the vision and mission of the university, all the staff members are empowered to initiate disciplinary procedure by filling in a standard form which in turn may lead to the constitution of an inquiry committee and further proceedings.

                                                </p>

                                            </div>

                                        </div>

                                    </div>

                                </article>

                            </div>

                        </div>

                    </div>

                </section>


                {/* CLOSING BAND */}

                <section className="bg-[#071A2F] text-white">

                    <div className="mx-auto grid w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)] lg:grid-cols-[.72fr_1.28fr]">

                        <div className="border-b border-white/10 py-16 lg:border-b-0 lg:border-r lg:py-20 lg:pr-14">

                            <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#D5AD57]">
                                Student Community
                            </span>

                            <h2 className="mt-5 font-['Libre_Caslon_Display',Georgia,serif] text-[38px] font-normal leading-[1.1]">
                                Responsibility begins with every student.
                            </h2>

                        </div>


                        <div className="flex items-center py-16 lg:py-20 lg:pl-16">

                            <p className="max-w-[760px] text-[16px] leading-8 text-white/60">
                                Respect for academic standards, University property, fellow students and institutional policies helps create a disciplined, inclusive and productive environment for the entire University community.
                            </p>

                        </div>

                    </div>

                </section>

            </main>

            <Footer />
        </>
    );
}